import { Card } from "../../../../components/Card";
import { Skeleton } from "../../../../components/Skeleton";

export const CertificationReviewSkeleton = () => {
    return (
        <Card className="flex flex-col gap-4 h-[calc(100vh-180px)]">
            <div className="flex justify-between items-center">
                <div className="flex items-center gap-4">
                    <div className="flex items-center gap-4">
                        <Skeleton className="w-[70px] h-[70px] rounded-full" />
                    </div>
                    <div className="flex flex-col gap-1.5">
                        <Skeleton className="w-[150px] h-4" />
                        <Skeleton className="w-[250px] h-4" />
                        <Skeleton className="w-[200px] h-4" />
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <Skeleton className="w-32 h-4" />
                    <Skeleton className="w-32 h-4" />
                    <Skeleton className="w-32 h-4" />
                </div>
            </div>
            <div className="flex border border-[#DFDFDF] w-full rounded-[10px] p-3 h-[calc(100vh-300px)]">
                <div className="flex flex-col gap-2">
                    <Skeleton className="w-[300px] h-11" />
                    <Skeleton className="w-[300px] h-11 !rounded-r-[0px]" />
                    <Skeleton className="w-[300px] h-11" />
                    <Skeleton className="w-[300px] h-11" />
                    <Skeleton className="w-[300px] h-11" />
                    <Skeleton className="w-[300px] h-11" />
                    <Skeleton className="w-[300px] h-11" />
                    <Skeleton className="w-[300px] h-11" />
                    <Skeleton className="w-[300px] h-11" />
                    <Skeleton className="w-[300px] h-11" />
                    <Skeleton className="w-[300px] h-11" />


                </div>
                <div className="flex flex-1 h-[inherit] flex-col pl-4 relative">
                    <div className="absolute top-[52px] left-0 w-full h-full">
                        <Skeleton className="w-4 h-11 rounded-[0px]" />
                    </div>
                    <div className="bg-gray-100 px-4 py-2.5 h-[calc(100%-24px)] rounded-[10px]">
                        <div className="flex justify-between items-center mb-4">

                        <Skeleton className="w-48 h-6" />
                        <Skeleton className="w-32 h-10" />

                        </div>
                        <Skeleton className="w-60 h-6" />
                        <Skeleton className="w-full h-60 mt-4" />
                        

                    </div>
                </div>
                <div className="flex ml-4 flex-1 h-[calc(100%-0px)] bg-gray-100 px-4 py-2.5 flex-col gap-2 rounded-[10px]">
                    <Skeleton className="w-2/3 h-6" />
                    <Skeleton className="w-1/2 h-4 mt-4" />
                    <Skeleton className="w-full h-24" />
                    <Skeleton className="w-1/2 h-4 mt-4" />
                    <Skeleton className="w-full h-[calc(100%-90px)]" />

                </div>
            </div>
        </Card>
    );
};